import { useEffect, useRef } from "react";

export default function InfiniteScrollSentinel({
  enabled,
  loading,
  onVisible,
}) {
  const sentinelRef = useRef(null);

  useEffect(() => {
    const element = sentinelRef.current;
    if (!element || !enabled) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !loading) onVisible();
      },
      { rootMargin: "400px 0px" }
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [enabled, loading, onVisible]);

  return <div ref={sentinelRef} className="catalog-sentinel" aria-hidden />;
}
